﻿import React, {useMemo} from 'react';
import {Autocomplete, AutocompleteProps, TextField} from "@mui/material";
import {AutocompleteOption} from "../SortFilter/interfaces";
import {useAutocompleteOptions} from "../../hooks/autocomplete/useAutocompleteOptions";
import {useGetLocationNames} from "../../hooks/location/useGetLocationNames";

interface LocationNameAutocompleteProps extends Omit<AutocompleteProps<any, any, any, any>, 'renderInput' | 'options'> {
}

/**
 * Autocomplete that handles managing the locationNames + ids for you, the value sent back is the id of the location
 * selected
 * @param props passthrough props to the internal MUI Autocomplete (minus a couple that are handled internally)
 */
const LocationNameAutocomplete = (props: LocationNameAutocompleteProps) => {
  const {
    locationNames,
    isLoading
  } = useGetLocationNames();

  const locationOptions = useMemo<Array<AutocompleteOption>>(() => [
    { id: '', label: 'All'},
    ...(locationNames?.map(location => ({id: location.id, label: location.locationName})) || [])
  ], [locationNames]);

  const renderInput = (params: any) => <TextField {...params} label="Location" variant="standard" />

  const {
    handleGetOptionLabel,
    handleIsOptionEqualToValue,
    filterOptions,
  } = useAutocompleteOptions({ autocompleteOptions: locationOptions, filterMode: 'flexible' })

  return <Autocomplete
    disablePortal
    disableClearable
    filterOptions={filterOptions}
    getOptionLabel={handleGetOptionLabel}
    isOptionEqualToValue={handleIsOptionEqualToValue}
    options={locationOptions}
    renderInput={renderInput}
    loading={isLoading}
    {...props}
  />
}

export { LocationNameAutocomplete };
